import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginPage from "./pages/LoginPage.jsx";
import DashboardPage from "./pages/DashboardPage.jsx";
import RestaurantPage from "./pages/RestaurantPage.jsx";
import AddRestaurantPage from "./pages/AddRestaurantPage.jsx";
import Sidebar from "./components/Sidebar.jsx";

const isAuth = () => !!localStorage.getItem("hubToken");

const Protected = ({ children }) => {
  if (!isAuth()) return <Navigate to="/login" replace />;
  return children;
};

export default function App() {
  const isLogin = !isAuth();
  return (
    <div style={{ display: isLogin ? "block" : "flex", minHeight: "100vh", background: "#f8fafc" }}>
      <ToastContainer position="top-right" theme="light" />
      {!isLogin && <Sidebar />}
      <div style={{ flex: 1, minWidth: 0 }}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Protected><DashboardPage /></Protected>} />
          <Route path="/restaurants/new" element={<Protected><AddRestaurantPage /></Protected>} />
          <Route path="/restaurants/:id" element={<Protected><RestaurantPage /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}
